(function initializeKvscheHeader() {
  if (window.KvscheHeaderController) return;

  var state = {
    nav: null,
    headerGroup: null,
    navSection: null,
    resizeObserver: null,
    mutationObserver: null,
    frame: 0
  };

  function scheduleMeasure() {
    if (state.frame) return;
    state.frame = window.requestAnimationFrame(function () {
      state.frame = 0;
      measureHeader();
    });
  }

  function measureHeader() {
    if (!(state.nav instanceof HTMLElement) || !document.body) return;

    var navHeight = Math.round(state.nav.getBoundingClientRect().height);
    if (navHeight < 1) return;

    var groupHeight = navHeight;
    if (state.headerGroup instanceof HTMLElement) {
      Array.prototype.forEach.call(state.headerGroup.children, function (child) {
        if (!(child instanceof HTMLElement) || child === state.navSection || child.contains(state.nav)) return;
        groupHeight += Math.round(child.getBoundingClientRect().height);
      });
    }

    document.body.style.setProperty('--header-height', navHeight + 'px');
    document.body.style.setProperty('--header-group-height', groupHeight + 'px');
  }

  function updateScrollState() {
    if (state.nav instanceof HTMLElement) {
      state.nav.classList.toggle('kv-nav--scrolled', window.scrollY > 60);
      scheduleMeasure();
    }
  }

  function observeSizes() {
    if (state.resizeObserver) state.resizeObserver.disconnect();
    if (!('ResizeObserver' in window)) return;

    state.resizeObserver = new ResizeObserver(scheduleMeasure);
    if (state.nav instanceof HTMLElement) state.resizeObserver.observe(state.nav, { box: 'border-box' });

    if (state.headerGroup instanceof HTMLElement) {
      Array.prototype.forEach.call(state.headerGroup.children, function (child) {
        if (child instanceof HTMLElement && child !== state.navSection && !child.contains(state.nav)) {
          state.resizeObserver.observe(child);
        }
      });
    }
  }

  function bindHeader() {
    state.nav = document.querySelector('.kv-nav');
    state.headerGroup = document.querySelector('#header-group');
    state.navSection = state.nav ? state.nav.closest('.shopify-section') : null;
    if (state.nav instanceof HTMLElement && state.nav.dataset.kvscheHeaderBound !== 'true') {
      state.nav.dataset.kvscheHeaderBound = 'true';
      state.nav.addEventListener('transitionend', scheduleMeasure);
    }
    observeSizes();
    updateScrollState();
    scheduleMeasure();
  }

  function observeHeaderGroup() {
    if (state.mutationObserver) state.mutationObserver.disconnect();
    if (!(state.headerGroup instanceof HTMLElement)) return;

    state.mutationObserver = new MutationObserver(bindHeader);
    state.mutationObserver.observe(state.headerGroup, { childList: true, subtree: true });
  }

  function rebindHeader() {
    bindHeader();
    observeHeaderGroup();
  }

  window.addEventListener('scroll', updateScrollState, { passive: true });
  window.addEventListener('resize', scheduleMeasure, { passive: true });
  document.addEventListener('shopify:section:load', rebindHeader);
  document.addEventListener('shopify:section:unload', rebindHeader);
  document.addEventListener('shopify:section:reorder', rebindHeader);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(scheduleMeasure);
  }

  window.KvscheHeaderController = {
    measure: scheduleMeasure,
    rebind: rebindHeader
  };

  rebindHeader();
})();
